import React from "react";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state";
import { User } from "../../entities/User";
import { defaultUserData } from "../../types/authTypes";
import { getLoginData } from "../../services/LocalStorage/loginDataLS";

const initialState: User =
  getLoginData() !== undefined ? getLoginData() : defaultUserData;

export const loginSlice = createSlice({
  name: "loginSlice",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      return {
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        access_token_exp: action.payload.access_token_exp,
        refresh_token_exp: action.payload.refresh_token_exp,
        userId: action.payload.userId,
        userName: action.payload.userName,
        role: action.payload.role,
        email: action.payload.email,
        profileImage: action.payload.profileImage,
        headerImage: action.payload.headerImage,
        userData: action.payload.userData,
        collection: action.payload.collection,
        social_networks: action.payload.social_networks,
        item_count: action.payload.item_count,
      };
    },
    cleanLogin: (state) => {
      return defaultUserData;
    },
  },
});

export const selectLogin = (state: RootState): User => state.login;

export const { setLogin, cleanLogin } = loginSlice.actions;
export default loginSlice.reducer;
